import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { activityService } from '../../services/activityService';

export const useGetTaxReports = params => {
  return useQuery({
    enabled: !!params?.type,
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.activity.tax_report, params],
    queryFn: () =>
      activityService.taxReports(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return {
          sale_proceeds: 0,
          fees: 0,
          net_proceeds: 0,
          notes_text: 'string',
        };
      }),
  });
};
